import React from 'react'
import useBusinessTravellerSocieteDetailsFetcher from 'businessTraveller/hooks/useBusinessTravellerSocieteDetailsFetcher'
import useSocieteCampaign from 'loyalty/hooks/useSocieteCampaign'
import { LEBT_SOCIETE_CAMPAIGN_SLUG } from 'loyalty/constants/loyaltyRoutes'
import { isAtOrAboveLoyaltyTier } from 'loyalty/utils/isAtOrAboveLoyaltyTier'
import SocieteCampaignTierCardContent from './SocieteCampaignTierCardContent'
import useSocieteCampaignTargetTier from 'loyalty/hooks/useSocieteCampaignTargetTier'

interface Props {
  onLearnMoreClick?: () => void
}

function SocieteCampaignTierCard(props: Props) {
  const { onLearnMoreClick } = props
  const campaign = useSocieteCampaign(LEBT_SOCIETE_CAMPAIGN_SLUG)
  const { targetTier, targetTierDisplayName } = useSocieteCampaignTargetTier()
  const { societeTierSetting, linkedCreditAccount, employeeSociete } = useBusinessTravellerSocieteDetailsFetcher(targetTier)

  const isAtOrAboveTargetTier = isAtOrAboveLoyaltyTier(linkedCreditAccount?.tier, targetTier)

  // Hide when: societe setting not enabled, or user already has the target tier or above and was NOT recently granted, or no campaign
  if (!societeTierSetting?.enabled || (isAtOrAboveTargetTier && !employeeSociete?.isSocieteRecentlyGranted) || !campaign) return null

  return <SocieteCampaignTierCardContent
    campaign={campaign}
    targetTier={targetTier}
    targetTierDisplayName={targetTierDisplayName}
    societeTierSetting={societeTierSetting}
    linkedCreditAccount={linkedCreditAccount}
    isAtOrAboveTargetTier={isAtOrAboveTargetTier}
    employeeSociete={employeeSociete}
    onLearnMoreClick={onLearnMoreClick}
  />
}

export default SocieteCampaignTierCard
